import BasePage from '../../../../../../components/table_page';
import Form from '../form';

export default {
  name: 'sale_plan',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_sale_plan_list');
  },
  methods: {
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openDrawer();
      }
    },
  },
};
